import "ngstorage";

import {REFERENCE_SCREENS} from "../../variables";

class QuestiononeController {
  constructor($localStorage, $rootScope, $scope, $state, $stateParams, AuthService, EnvService, SecurityService, $timeout, TrackingService, events) {
    this.name = "questionone";
    //this.walkthroughState = WALKTHROUGH_STATES.ARRIVAL_INSTRUCTIONS;

    this.$localStorage = $localStorage;
    this.$rootScope = $rootScope;
    this.$scope = $scope;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.$auth = AuthService;
    this.$env = EnvService;
    this.$security = SecurityService;
    this.$timeout = $timeout;
    this.$tracking = TrackingService;
    this.$events = events;
    this.answer = null;
    this.disableButton = true;
    this.referenceScreens = REFERENCE_SCREENS;
  }

  $onInit() {
    console.log("init question one");
    console.dir(this.event);
  }

  goNext() {
    this.$timeout(() => {
      this.$rootScope.$emit("SendToNextReferenceScreen", {
        referenceScreen: this.referenceScreens.QUESTION_ONE,
      });
    });
  }

  saveAnswer() {

    let data = {};

    this.setLoader();
    data.questionId = this.determineReferenceTypeAndReturnProoperQuestionId();
    data.answer = this.answer;
    data.userReferenceId = this.event.rid;

    this.$security.saveReferenceQuestion(data).then(
      (response) => {
        this.unSetLoader();
        this.goNext();
      },
      (error) => {
        this.unSetLoader();
        alert("error saving answer");
      }
    );
  }

  selectionSelected(answer) {
    this.disableButton = false;
    this.answer = answer;
  }

  determineReferenceTypeAndReturnProoperQuestionId() {

    let result;

    if (this.event.referenceType === "PROFESSIONAL") {
      result = this.$security.findQuestionId("work as a", this.event.questions);
    } else {
      result = this.$security.findQuestionId("Would you hire this ##JobblerName## for a##ListedJobTitle## role", this.event.questions);
    }

    return result;

  }

  disableNextButton() {
    if (!this.answer) {
      this.disableButton = true;
    } else {
      this.disableButton = false;
    }
  }

  setLoader() {
    this.$timeout(() => {
      $("html").addClass("wait");
    });
  }

  unSetLoader() {
    this.$timeout(() => {
      $("html").removeClass("wait");
    });
  }
}

QuestiononeController.$inject = [
  "$localStorage",
  "$rootScope",
  "$scope",
  "$state",
  "$stateParams",
  "auth",
  "env",
  "security",
  "$timeout",
  "tracking",
  "events",
];

export default QuestiononeController;



// WEBPACK FOOTER //
// ./client/app/scenes/references/scenes/questionone/questionone.controller.js